var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6243 5.6388C18.4174 4.85991 17.8068 4.24532 17.032 4.0364C15.6284 3.6571 9.99976 3.6571 9.99976 3.6571C9.99976 3.6571 4.37111 3.6571 2.96749 4.0364C2.19267 4.24532 1.58213 4.85788 1.37524 5.6388C1 7.05052 1 9.99973 1 9.99973C1 9.99973 1 12.9469 1.37524 14.3607C1.58213 15.1396 2.19267 15.7541 2.96749 15.9631C4.37111 16.3424 9.99976 16.3424 9.99976 16.3424C9.99976 16.3424 15.6284 16.3424 17.032 15.9631C17.8068 15.7541 18.4153 15.1416 18.6243 14.3607C18.9995 12.9469 18.9995 9.99973 18.9995 9.99973C18.9995 9.99973 18.9995 7.05255 18.6243 5.6388Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15796 12.6662L12.8617 9.99077L8.15796 7.31335V12.6662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9995,
    height: 12.6853,
    fill: "white",
    transform: "translate(1 3.6571)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6d4f3113df910c358e00d82d8cf27ca7.svg";
export { ForwardRef as ReactComponent };